module.exports = __webpack_public_path__ + "img/new6.9aabc8b0.jpg";